module.exports = __webpack_public_path__ + "media/stylesheets/images/start-06522e3b3146af6ab71bceba76336559.png";